import { aboutData } from '@/mocks/homeData';

export default function AboutSection() {
  return (
    <section id="about" className="py-14 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="w-full max-w-[960px] mx-auto">
        <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 text-center mb-6">
          {aboutData.title}
        </h2>
        <p className="text-base text-foreground-600 leading-relaxed text-center max-w-3xl mx-auto mb-8">
          {aboutData.description}
        </p>
        <div className="flex flex-wrap items-center justify-center gap-8 md:gap-14">
          {aboutData.stats.map((stat) => (
            <div key={stat.label} className="text-center">
              <div className="font-heading text-3xl md:text-4xl text-primary-500 mb-1">
                {stat.value}
              </div>
              <div className="text-sm text-foreground-500">{stat.label}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}